import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';

import { APP_DEFAULT_PATH } from 'config';
import { getDefaultPathForUser, getUser, isAuthenticated } from 'utils/auth';

// Redirect logged-in users away from login/register pages

export default function GuestRoute({ children }) {
  if (isAuthenticated()) {
    const user = getUser();
    const path = user ? getDefaultPathForUser(user) : APP_DEFAULT_PATH;
    return <Navigate to={path} replace />;
  }

  return children;
}

GuestRoute.propTypes = { children: PropTypes.node };
